var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatumLogoNotext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 441.65 435.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.14 0 89.17 50.83 221.19 278.99 221.19 381.14 1.14 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.14 0 89.17 50.83 353.2 50.83 441.23 0 1.14 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "441.23 0 353.2 50.83 221.19 278.99 221.19 381.14 441.23 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.89,106.6A18.08,18.08,0,1,0,243,124.68,18.1,18.1,0,0,0,224.89,106.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.13,285.62c116.43,16.38,144.86,52.05,143,69-2.84,26.43-89.36,56.17-203.34,56.23S20.32,381,17.48,354.58c-1.82-16.91,26.61-52.58,143.05-69C74.9,287.18,0,315.27,0,357.87c.05,42.92,98.7,77.73,220.59,77.89h.47c121.89-.16,220.55-35,220.59-77.89C441.7,315.27,366.75,287.18,281.13,285.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatumLogoNotext);
export default __webpack_public_path__ + "static/media/datum_logo_notext.864c74b8cd4ea78b99794acc4d420186.svg";
export { ForwardRef as ReactComponent };